/**
 * Native mobile app store URLs + the viewport breakpoint below which the
 * web lobby is replaced by the "Get the app" gate.
 *
 * Breakpoint mirrors the sidebar mobile threshold in apps/web/src/layouts/
 * RootLayout.tsx and PublicLayout.tsx — keep these aligned so the lobby
 * gate matches the layout's own mobile cutoff.
 *
 * Play Store URL is derivable from the Android applicationId in
 * apps/mobile/android/app/build.gradle.kts.
 *
 * App Store URL uses the numeric Apple App ID from App Store Connect →
 * My Apps → Polymyth → App Information → "Apple ID" field.
 */

export const APP_STORE_URL = 'https://apps.apple.com/app/polymyth/id6770557982';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.polymyth.polymyth_mobile';

export const MOBILE_BREAKPOINT_PX = 1024;
